/**
 * EPIC PAT strings.
 *
 * Arabic is the source language (CONVENTIONS §8), so every key exists here
 * first and `en.ts` falls back to this file for anything it lacks.
 *
 * Scope note: the patient screens render most of their copy inline rather than
 * through `t()`. That is deliberate for this epic - the strings are transcribed
 * verbatim from `design/MedOSOps.dc.html` and keeping them beside the markup is
 * what makes them checkable against the design. What lives here is the
 * vocabulary that appears in more than one place, or that another epic needs:
 * navigation, statuses, priorities, condition categories and the alert
 * summaries the appointment and waiting-room screens also show.
 */
export const patientsAr: Record<string, string> = {
  // --- Navigation and screens ----------------------------------------------
  'patients.title': 'سجل المرضى',
  'patients.profile.title': 'ملف المريض',
  'patients.merge.title': 'دمج ملفَّي مريض',
  'patients.new': 'مريض جديد',
  'patients.quickCreate': 'إنشاء مريض جديد سريعاً',
  'patients.search.placeholder': 'اسم، جوال، رقم ملف، أو هوية…',

  // --- Statuses -------------------------------------------------------------
  'patientStatus.ACTIVE': 'نشط',
  'patientStatus.ARCHIVED': 'مؤرشف',
  'patientStatus.MERGED': 'مدموج',

  // --- Priority -------------------------------------------------------------
  'patientPriority.NORMAL': 'عادي',
  'patientPriority.HIGH': 'أولوية',
  'patientPriority.VIP': 'كبار الزوار',

  // --- Gender ---------------------------------------------------------------
  'gender.MALE': 'ذكر',
  'gender.FEMALE': 'أنثى',
  'gender.UNSPECIFIED': 'غير محدد',

  // --- Condition categories -------------------------------------------------
  'conditionCategory.ALLERGY': 'حساسية',
  'conditionCategory.CHRONIC_DISEASE': 'مرض مزمن',
  'conditionCategory.ACTIVE_PROBLEM': 'مشكلة نشطة',
  'conditionCategory.PREGNANCY': 'حمل',
  'conditionCategory.FAMILY_HISTORY': 'تاريخ عائلي',
  'conditionCategory.SOCIAL_HISTORY': 'تاريخ اجتماعي',
  'conditionCategory.SURGERY': 'عملية جراحية',
  'conditionCategory.VACCINATION': 'تطعيم',
  'conditionCategory.OTHER': 'أخرى',

  // --- Severity -------------------------------------------------------------
  'severity.MILD': 'خفيفة',
  'severity.MODERATE': 'متوسطة',
  'severity.SEVERE': 'شديدة',
  'severity.CRITICAL': 'حرجة',

  // --- Alert summaries ------------------------------------------------------
  // These are the *safe* forms. A user without the underlying permission sees
  // exactly these and never the substance behind them (PAT-018).
  'patientAlert.allergy': 'حساسية',
  'patientAlert.criticalCondition': 'حالة حرجة',
  'patientAlert.pregnancy': 'حمل',
  'patientAlert.overdueFollowUp': 'متابعة متأخرة',
  'patientAlert.upcomingAppointment': 'موعد قادم',
  'patientAlert.outstandingBalance': 'رصيد مستحق',
  'patientAlert.consentMissing': 'لا توجد موافقة على التواصل',
  'patientAlert.redacted': 'التفاصيل تتطلب صلاحية إضافية',

  // --- Field-permission vocabulary -----------------------------------------
  'patients.fieldHidden': 'مخفي',
  'patients.fieldHidden.title': 'ليس لديك صلاحية عرض هذا الحقل',
};
